import firebase from 'firebase';
import API_KEYS from './constants/apiKeys';


firebase.initializeApp({
    apiKey: API_KEYS.FIREBASE_API_KEY,
    authDomain: 'book-clear-h2o.firebaseapp.com',
    databaseURL: 'https://book-clear-h2o.firebaseio.com',
    projectId: 'book-clear-h2o',
    storageBucket: 'book-clear-h2o.appspot.com',
    messagingSenderId: '32026321272',
    appId: '1:32026321272:web:b5f455da05fb7b6a1e688d'
});

export const db = firebase.firestore();

export const COLLECTION_BOOKINGS = API_KEYS.COLLECTION_BOOKINGS_REF;
export const COLLECTION_BOOKING_DATES_REF = API_KEYS.COLLECTION_BOOKING_DATES_REF;

export const SYSTEM_LOGIN = {
    USER: process.env.REACT_APP_SYSTEM_USERNAME,
    PASSWORD: process.env.REACT_APP_SYSTEM_PASSWORD,
};

export default firebase;
